function updateMix(e) {
  const mixcloudWrapper = document.querySelector('.mixcloud-wrapper iframe');
  const currentMixContainers = document.querySelectorAll('span.current-mix-title');
  e.stopPropagation();
  document.querySelector('.mixcloud-wrapper').hidden = false;
  // console.log(e.target);
  let newMix = {
    src: `https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&mini=1&hide_artwork=0&autoplay=1&feed=/Sub_Sun/${e.target.getAttribute(
      'data-mix-src'
    )}/`,
    name: e.target.getAttribute('data-mix-name'),
  };
  // Update src
  mixcloudWrapper.src = newMix.src;

  // Update mix title (multiple needed for marquee effect)
  currentMixContainers.forEach((item) => {
    item.innerHTML = newMix.name;
  });
}

function openModal(e) {
  const target = e.target.getAttribute('data-target');
  document.querySelector(target).showModal();
}

function closeModal(e) {
  e.target.closest('dialog').close();
}

function dialogClickHandler(e) {
  if (e.target.tagName !== 'DIALOG')
    //This prevents issues with forms
    return;

  const rect = e.target.getBoundingClientRect();

  const clickedInDialog =
    rect.top <= e.clientY &&
    e.clientY <= rect.top + rect.height &&
    rect.left <= e.clientX &&
    e.clientX <= rect.left + rect.width;

  if (clickedInDialog === false) e.target.close();
}

addEventListener('load', () => {
  const buttons = document.querySelectorAll('.btn.btn-mixes');
  const playButtons = document.querySelectorAll('button.play');
  const closeButtons = document.querySelectorAll('button.close');
  const dialogs = document.querySelectorAll('dialog');

  buttons.forEach((item) => {
    item.addEventListener('click', openModal);
  });

  playButtons.forEach((item) => {
    item.addEventListener('click', updateMix);
  });

  closeButtons.forEach((item) => {
    item.addEventListener('click', closeModal);
  });

  dialogs.forEach((item) => {
    item.addEventListener('click', dialogClickHandler);
  });
});
